var map = {
	"./icon1-1.png": "0fbb",
	"./icon1-2.png": "6862",
	"./icon2-1.png": "ef90",
	"./icon2-2.png": "1182",
	"./integral-bg.png": "e4df",
	"./integral-bg2.png": "68c4",
	"./integral-shouru.png": "fd09",
	"./integral-zhichu.png": "1cb8",
	"./quota1.png": "d2ef",
	"./quota2.png": "674d",
	"./tip.png": "d96b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8d3";